module.exports = __webpack_public_path__ + "static/media/MainEditBlue.658bcaca.svg";